<template>
    <div class="book" v-if="book">
        <div class="cover">
            <div class="filler"></div>
            <Image :image="book.cover" :height="400" :width="400" :mobileHeight="824" imageClass="cover" />
        </div>
        <div class="info">
            <div class="helvetica title5">{{ book.title }}</div>
            <div class="description">{{ book.summary }}</div>
            <div class="pricingTable">
                <div class="row" v-if="hardcopyPrice">
                    <div class="price baron">€ {{ hardcopyPrice }}</div>
                    <div class="desc">for hardcopy</div>
                </div>
                <div class="row" v-if="electronicCopyPrice">
                    <div class="price baron">€ {{ electronicCopyPrice }}</div>
                    <div class="desc">for electronic copy</div>
                </div>
            </div>
        </div>
        <div class="readLink"><span class="title6 helvetica">Details</span> →</div>

        <NuxtLink class="overlink" :to="{ name: 'publications-bookshop-slug', params: { slug: book.url } }"></NuxtLink>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ book: any }>()

const hardcopyPrice = computed(() => {
    if (props.book && props.book.price_hardcopy) {
        return parseFloat(props.book.price_hardcopy).toFixed(2).replace('00', '-')
    } else return null
})
const electronicCopyPrice = computed(() => {
    if (props.book && props.book.price_electronic_copy) {
        return parseFloat(props.book.price_electronic_copy).toFixed(2).replace('00', '-')
    } else return null
})
</script>

<style lang="scss" scoped>
.book {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--size-gutter-default);

    .cover {
        width: 100%;
        background-color: var(--color-sand);
        position: relative;

        .filler {
            padding-top: 100%;
        }

        &:deep(.responsivePicture) {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
        }
    }

    .info {
        display: flex;
        flex-direction: column;
        gap: var(--size-gutter-small);

        .title5 {
            text-wrap: balance;
        }

        .description {
            text-wrap: balance;
        }

        .pricingTable {

            .row {
                display: grid;
                grid-template-columns: 72px 1fr;
                align-items: baseline;
            }
        }
    }

    .readLink {
        color: var(--color-primary);
    }
}
</style>